import React from 'react';
import { Message, Grid } from 'semantic-ui-react';
import { FertilizerEventUuid } from 'services/fertilizerEvents/types';
import { SprayEventUuid } from 'services/sprayEvents/types';

export interface Props {
    uuids: SprayEventUuid[] | FertilizerEventUuid[];
    dates: string[];
    eventName: string;
    eventPluralName: string;
}

export default function DeleteEventModalMessage(
    props: Props
): React.ReactElement {
    const { dates, uuids, eventName, eventPluralName } = props;

    if (uuids.length > 1) {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <p>
                            Are you sure you want to delete {uuids.length}{' '}
                            {eventPluralName} for the following date
                            {`${dates.length > 1 ? 's' : ''}`}?
                        </p>
                        <Message warning>{dates.join(', ')}</Message>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

    return <p>Are you sure you want to delete the selected {eventName}?</p>;
}
